import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

import { type ChildRouteContext } from "@/root";
import { fetchMeQueryOptions } from "@/user/services";

import LayoutSkeleton from "../../components/loadings/skeleton/LayoutSkeleton";
import TableSkeleton from "../../components/loadings/skeleton/TableSkeleton";
import Layout from "../../layouts/Layout";
import { useRouterLayout } from "../../layouts/useRouterLayout";

export const Route = createFileRoute("/admin/_panel")({
  beforeLoad: async ({ context, location }) => {
    try {
      const user = await context.queryClient.ensureQueryData(
        fetchMeQueryOptions(),
      );

      if (!user) {
        throw new Error("User not found");
      }

      return { user } satisfies ChildRouteContext;
    } catch (error) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: Component,
  pendingComponent: () => (
    <LayoutSkeleton>
      <TableSkeleton />
    </LayoutSkeleton>
  ),
  staticData: { admin: true },
});

function Component() {
  const { hideMenu, hideHeader, hideCrumb, hideWidgets, isCompact } =
    useRouterLayout();
  return (
    <Layout
      isAdmin
      hideMenu={hideMenu}
      hideHeader={hideHeader}
      hideCrumb={hideCrumb}
      hideWidgets={hideWidgets}
      isCompact={isCompact}
    >
      <Outlet />
    </Layout>
  );
}
